/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoDefs from './defs.defs.js'

const $nsid = 'com.atproto.repo.deleteRecord'

export { $nsid }

/** Delete a repository record, or ensure it doesn't exist. Requires auth, implemented by PDS. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    repo: l.string({ format: 'at-identifier' }),
    collection: l.string({ format: 'nsid' }),
    rkey: l.string({ format: 'record-key' }),
    swapRecord: l.optional(l.string({ format: 'cid' })),
    swapCommit: l.optional(l.string({ format: 'cid' })),
  }),
  l.jsonPayload({
    commit: l.optional(
      l.ref<RepoDefs.CommitMeta>((() => RepoDefs.commitMeta) as any),
    ),
  }),
  ['InvalidSwap'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
